// @flow
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import striptags from 'striptags';

import { InputDatalist } from 'Components/frameworks/form-inputs/input-datalist/InputDatalist.jsx';
import { ICONS } from 'Components/utils/icon/icons';
import { useAutocomplete } from 'Src/hooks/use-autocomplete/useAutocomplete';
import { t } from 'Src/i18n';
import { changeSearchQuery } from 'Store/faceting/facetingSearch.action';
import { setKeywords } from 'Store/search/query/searchQuery.action';
import { keywordsSelector } from 'Store/search/search.selector';

type Props = {
  onQueryChange: (query: SearchQuery) => mixed,
};

export const CriteriaQuery = (props: Props) => {
  const keywords: string = useSelector(keywordsSelector);
  const query: SearchQuery = useSelector(state => state.faceting.query);
  const dispatch = useDispatch();

  const { setAutocompleteQuery, autocompleteResults, setAutocompleteResults } = useAutocomplete(
    keywords,
  );

  return (
    <InputDatalist
      iconLeft={ICONS.SEARCH_GLASS}
      dataList={autocompleteResults}
      size="large"
      onSelect={({ label, item: { type, link } }) => {
        const searchQuery = {
          label,
          type,
          link,
        };
        dispatch(changeSearchQuery(searchQuery));
        props.onQueryChange(searchQuery);
      }}
      onChange={(_, value: string) => {
        const cleanKeywords = striptags(value);
        dispatch(setKeywords(cleanKeywords));
        setAutocompleteQuery(cleanKeywords);
      }}
      onClear={() => {
        setAutocompleteResults([]);

        if (!keywords) {
          // User is clearing the search query
          dispatch(changeSearchQuery({ label: '' }));
        }

        dispatch(setKeywords(''));
        setAutocompleteQuery('');
      }}
      hasClear
      isAnimated
      placeholder={t('faceting.searchTitle')}
      value={query && query.label ? query.label : keywords}
    />
  );
};
